export default "__VITE_ASSET__8625a5ca__"